import React, { memo } from "react";
import { View, Modal, TouchableOpacity, StyleSheet } from "react-native";
import color from "@constants/color";
import { width } from "@constants/metrics";
import Text from "@components/CustomText";
import t from "@constants/localization";

interface Props {
  onPress?: () => void;
  visible?: boolean;
  onPressCancel?: () => void;
  title?: string;
  text?: string;
  disableBtn?: boolean;
}
const PATH = "screens/MyDeliveries/components/MarkingConfirmationModal";
const MarkingConfirmationModal = (props: Props) => {
  const {
    onPress = () => {},
    visible = true,
    onPressCancel = () => {},
    title = "",
    text = "",
    disableBtn = false,
  } = props;

  return (
    <Modal
      visible={visible}
      transparent={true}
      statusBarTranslucent
      navigationBarTranslucent
    >
      <TouchableOpacity style={styles.modalContainer} onPress={onPressCancel}>
        <View
          style={styles.modalContent}
          onStartShouldSetResponder={() => true}
        >
          <Text variant="subtitle_20" style={styles.headingText}>
            {title}
          </Text>
          <Text variant="body_text_3" style={styles.subHeadingText}>
            {text}
          </Text>
          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={[styles.button, styles.primaryButton]}
              onPress={onPress}
              disabled={disableBtn}
            >
              <Text variant="title_18_semi" style={styles.whiteButtonText}>
                {t(`${PATH}/yes`)}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.button, styles.whiteButton]}
              onPress={onPressCancel}
            >
              <Text variant="title_18_semi" style={styles.primaryButtonText}>
                {t(`${PATH}/no`)}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </TouchableOpacity>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: color.modalBackground,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    width: width - 64,
    backgroundColor: color.white,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 18,
    paddingVertical: 20,
    marginBottom: 20,
  },
  headingText: {
    color: color.Gray20,
    paddingVertical: 8,
  },
  subHeadingText: {
    color: color.mediumBlacklightBlack,
    textAlign: "center",
  },
  buttonContainer: {
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  button: {
    marginTop: 16,
    marginHorizontal: 12,
    paddingVertical: 4,
    borderWidth: 1,
    borderRadius: 20,
    flex: 1,
    alignItems: "center",
  },
  primaryButton: {
    borderColor: color.plain_green,
    backgroundColor: color.plain_green,
  },
  whiteButton: {
    borderColor: color.mediumBlacklightBlack,
    backgroundColor: color.white,
  },
  buttonText: {
    fontSize: 18,
    fontWeight: "500",
    lineHeight: 22,
  },
  primaryButtonText: {
    color: color.mediumBlacklightBlack,
  },
  whiteButtonText: {
    color: color.white,
  },
});

export default memo(MarkingConfirmationModal);
